module.exports = __webpack_public_path__ + "static/media/lesdesktopapp.322972e2.gif";